// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['fontsizeselect bold italic underline strikethrough alignleft aligncenter alignright link preview forecolor backcolor']

// const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter 
//     alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample', 'hr bullist numlist link 
//     image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen']
export default toolbar



// WEBPACK FOOTER //
// ./src/components/Tinymce/toolbar.js